import { ReactNode } from 'react'
import { ICheckoutContext } from 'types/contexts'
import { Venue, VenueEvent } from 'types/model'

import { CheckoutContext } from '@contexts/checkout'
import { SessionContext } from '@contexts/session'
import { ThemeContext } from '@contexts/theme'

import { VenuePageLayout } from '@modules/venue/layouts/venue-page-layout'
import { useAttribution } from '@hooks/attribution'
import GTM from '@components/gtm'
import { OrgInt } from 'types/model/orgInt'

export interface VenuePageProviderProps {
  children: ReactNode
  checkoutValues?: Partial<ICheckoutContext>
  venue: Venue
  integrations: OrgInt[]
  event?: VenueEvent | null
  themeOverride?: string | null
  eventPageBanner?: boolean
  largePageBanner?: boolean
  embeddedWidget?: boolean
}

export function VenuePageProvider({
  children,
  venue,
  integrations,
  event,
  themeOverride,
  checkoutValues,
  eventPageBanner,
  largePageBanner,
  embeddedWidget,
}: VenuePageProviderProps) {
  const { affiliateId, attributionId } = useAttribution()
  const _themeOverride = ['light', 'theme-light'].includes(themeOverride ?? '')
    ? 'light'
    : ['dark', 'theme-dark'].includes(themeOverride ?? '')
    ? 'dark'
    : undefined

  return (
    <>
      <SessionContext>
        <CheckoutContext
          venue={venue}
          event={event}
          affiliateId={affiliateId}
          attributionId={attributionId}
          initialValues={checkoutValues}
          embeddedWidget={embeddedWidget}
        >
          <ThemeContext venue={venue} themeOverride={_themeOverride}>
            <VenuePageLayout
              venue={venue}
              event={event}
              eventPoster={eventPageBanner}
              largeBanner={largePageBanner}
              minimalLayout={embeddedWidget}
            >
              {children}
            </VenuePageLayout>
          </ThemeContext>
        </CheckoutContext>
      </SessionContext>
      <GTM integrations={integrations} />
    </>
  )
}
